'use client'

import dynamic from 'next/dynamic'

const ClientOnlyGuard = dynamic(() => import('./ClientOnlyGuard'), {
  ssr: false
})

export default ClientOnlyGuard
